import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin, loginCliente, resetearPassword } from '../../services/authService';
import './LoginUnificado.css';

const LoginUnificado = () => {
  const navigate = useNavigate();
  const [tipoUsuario, setTipoUsuario] = useState('cliente');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [documento, setDocumento] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState('');
  const [resetError, setResetError] = useState('');

  const handleLoginAdmin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      if (!email || !password) {
        throw new Error('Email y contrasena son requeridos');
      }
      
      const resultado = await loginAdmin(email, password);
      
      const sesion = {
        type: resultado.type,
        email: resultado.user.email,
        uid: resultado.user.uid
      };
      sessionStorage.setItem('usuario', JSON.stringify(sesion));
      
      navigate('/dashboard');
      
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginCliente = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      if (!email || !documento) {
        throw new Error('Email y documento son requeridos');
      }
      
      const resultado = await loginCliente(documento, email);
      
      const sesion = {
        type: resultado.type,
        email: email,
        cliente: resultado.data
      };
      sessionStorage.setItem('usuario', JSON.stringify(sesion));
      
      navigate('/mi-espacio');
      
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!resetEmail) {
      setResetError('Debes ingresar tu correo electronico');
      return;
    }

    setResetLoading(true);
    setResetError('');
    setResetMessage('');

    try {
      await resetearPassword(resetEmail);
      setResetMessage('Se ha enviado un correo de restablecimiento. Revisa tu bandeja de entrada.');
      setTimeout(() => {
        setShowResetModal(false);
        setResetEmail('');
        setResetMessage('');
      }, 3000);
    } catch (error) {
      setResetError(error.message);
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="login-unificado-container">
      {/* Boton flotante solo visible en movil */}
      <button className="btn-volver-inicio-mobile" onClick={() => navigate('/')}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <div className="login-unificado-card">
        <div className="login-card-inner">
          {/* Boton dentro del card - visible solo en desktop */}
          <button className="btn-volver-inicio" onClick={() => navigate('/')}>
            <svg className="back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Volver al Inicio</span>
          </button>

          <div className="login-header">
            <h2>Golden Cars</h2>
            <p>Accede a tu espacio personal</p>
          </div>

          <div className="tipo-usuario-selector">
            <button 
              className={`tipo-btn ${tipoUsuario === 'cliente' ? 'active' : ''}`}
              onClick={() => setTipoUsuario('cliente')}
            >
              Cliente
            </button>
            <button 
              className={`tipo-btn ${tipoUsuario === 'admin' ? 'active' : ''}`}
              onClick={() => setTipoUsuario('admin')}
            >
              Administrador
            </button>
          </div>

          {tipoUsuario === 'cliente' ? (
            <form onSubmit={handleLoginCliente} className="login-form">
              <div className="input-group">
                <label>Correo Electronico</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="correo@ejemplo.com"
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Numero de Documento</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <input
                    type="text"
                    value={documento}
                    onChange={(e) => setDocumento(e.target.value)}
                    placeholder="123456789"
                    required
                  />
                </div>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="btn-ingresar" disabled={loading}>
                {loading ? 'Ingresando...' : 'Ingresar a Mi Espacio'}
              </button>
            </form>
          ) : (
            <form onSubmit={handleLoginAdmin} className="login-form">
              <div className="input-group">
                <label>Correo Electronico</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@ejemplo.com"
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Contraseña</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                </div>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="btn-ingresar" disabled={loading}>
                {loading ? 'Ingresando...' : 'Ingresar al Panel'}
              </button>

              <button 
                type="button" 
                className="btn-olvide-password"
                onClick={() => setShowResetModal(true)}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </form>
          )}

          <div className="login-footer">
            <p>Golden Cars – Peritaje & Respaldo Juridico S.A.S.</p>
            <p className="footer-slogan">"Mas que un peritaje, tu respaldo al comprar"</p>
          </div>
        </div>
      </div>

      {/* Modal para restablecer contraseña */}
      {showResetModal && (
        <div className="modal-overlay" onClick={() => setShowResetModal(false)}>
          <div className="modal-reset-content" onClick={e => e.stopPropagation()}>
            <div className="modal-reset-header">
              <h3>Restablecer Contraseña</h3>
              <button className="modal-reset-close" onClick={() => setShowResetModal(false)}>×</button>
            </div>
            <div className="modal-reset-body">
              <p>Ingresa tu correo electronico y te enviaremos un enlace para restablecer tu contraseña.</p>
              <div className="input-group">
                <label>Correo Electronico</label>
                <input
                  type="email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  placeholder="admin@ejemplo.com"
                  className="reset-input"
                />
              </div>
              {resetError && <div className="error-message reset-error">{resetError}</div>}
              {resetMessage && <div className="success-message">{resetMessage}</div>}
            </div>
            <div className="modal-reset-footer">
              <button 
                type="button" 
                className="btn-cancelar-reset"
                onClick={() => setShowResetModal(false)}
              >
                Cancelar
              </button>
              <button 
                type="button" 
                className="btn-enviar-reset"
                onClick={handleResetPassword}
                disabled={resetLoading}
              >
                {resetLoading ? 'Enviando...' : 'Enviar Correo'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginUnificado;